
<v-combobox
    v-model        = "selected"
    :items         = "contacts"
    item-text      = "name"
    item-value     = "id"
    class          = "mail-adress mt-0 pt-0 mb-0 pb-0"
    @change        = "onChange"
    autocomplete   = "off"
    autocorrect    = "off"
    autocapitalize = "off"
    spellcheck     = "false"
    :search-input.sync="search"
    hide-selected
    hide-details
    chips
    multiple
    clearable
    :key="refresh"
>
    <template v-slot:prepend-inner>
        <div class="mail-label v-flex">
            {{ label }}
        </div>
    </template>


    <!-- display selected contacts -->
    <template v-slot:selection="data">
        <p-recipient-chip
            :recipient = "data.item"
            :color     = "chipColor"
            @remove    = "onRemove"
        />
    </template>
    <!-- display selected contacts -->

    <template v-slot:no-data v-if="search">
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title>
                    <div class="pl-2">
                        <span>{{ $t('mail.contact.notfound') }}<strong>{{ search }}</strong>". Mit </span>
                        <v-icon size="22">mdi-keyboard-return</v-icon>
                        <span>wird die Email Adresse übernommen.</span>
                    </div>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </template>

    <template
        v-slot:item="data"
    >
        <v-row class="no-frame pt-1 pb-1" >
            <v-col class="no-frame">
                <div class="v-flex pl-2" style="font-size: 15px">
                    <div class="pr-2" style="margin-top: -2px;">
                        <v-icon size="18">{{ isPrefered (data.item) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                    </div>

                    <div style="margin-left: -5px;">
                        {{ data.item.company ? data.item.company.name : '---' }}
                    </div>
                </div>
                <div style="font-size: 12px; margin-left: 30px;" v-for="(role, index) in data.item.roles" :key="index">
                    {{ role.name }}
                </div>
            </v-col>
            <v-col class="no-frame">
                <div style="font-size: 16px">
                    {{ data.item.name }}
                </div>
                <div style="font-size: 12px">
                    {{ data.item.email }}
                </div>
            </v-col>
        </v-row>
    </template>
</v-combobox>
